import Vue from 'vue'
import MD5 from 'crypto-js/md5'
import {pbrAxios} from '../common/js/pbrAxios'
import $ from 'jquery'
import Cookies from 'js-cookie'

const isDev = process.env.NODE_ENV === 'development'

let allToken = '' // token
let service = '' // 秘钥
function queryURLParams (url) {
  let obj = {}
  url.replace(/([^?=&#]+)=([^?=&#]+)/g, (_, key, value) => obj[key] = value)
  return obj
}
// 用户验证接口
function getmembername () {
  let str = location.href
  let num = str.indexOf('#')
  str = str.substr(num + 1)
  const windowUrl = window.location.origin + '/login#' + str
  let url = '/api/pc/getmembername'
  if (!isDev) {
    url = window.location.origin + url
  }
  $.ajax({
    type: 'POST',
    async: false, // fasle表示同步请求，true表示异步请求
    xhrFields: {
      withCredentials: true
    },
    url, // 请求地址
    success: function (result) { // 请求成功
      if (!result.state) {
        removeCookie()
        window.location.href = windowUrl
      } else {
        service = result.data.token[0]
      }
    },
    error: function (e) {
      removeCookie()
      window.location.href = windowUrl
    }
  })
}
// 获取token
function getSilkRoadToken () {
  const useId = Cookies.get('imsilkroad_userid')
  const useName = Cookies.get('imsilkroad_username')

  if (useId && useName) {
    if (Cookies.get('imsilkroad_kgtoken')) {
      let cookieService = Cookies.get('imsilkroad_kgtoken')
      cookieService = window.atob(cookieService)
      const lastIndex = cookieService.lastIndexOf('(')
      service = cookieService.slice(0, lastIndex)
    } else {
      const query = queryURLParams(window.location.href)
      service = sessionStorage.getItem('imsilkroad_kgtoken') || query.token || ''
      if (!service) {
        getmembername()
      }
    }
  } else {
    // 进行用户验证
    getmembername()
  }
  let _token = `${service}:${useId}:${useName}`
  _token = window.btoa(encodeURI(_token))
  // _token = window.btoa(_token)
  let baseUrl = window.OauthConfig.brpaUrl
  const url = `${window.OauthConfig.pdBase + '/kgapi'}/auth/getToken`
  $.ajax({
    type: 'POST',
    async: false, // fasle表示同步请求，true表示异步请求
    xhrFields: {
      withCredentials: true
    },
    contentType: 'application/json;charset=UTF-8',
    url, // 请求地址
    data: JSON.stringify({token: _token}), // 数据，json字符串
    success: function (result) { // 请求成功
      if (result.errCode === 200) {
        let _data = result.data
        allToken = _data
        window.allToken = _data
        creastTimeToken()
      }
    },
    error: function (e) {
    }
  })
}
function creastTimeToken () {
  window.pdTokenINterval && clearTimeout(window.pdTokenINterval)
  window.pdTokenINterval = setTimeout(() => {
    allToken = ''
    window.allToken = ''
  }, 270000)
}
function checkSilkRoadToken () {
  return window.allToken
}

/**
 * 验证当前登录用户，并注入cookie
 * @param params
 * @returns {AxiosPromise<any>}
 */
const checkUserId = () => {
  let uid = parseInt(Cookies.get('imsilkroad_userid')) // 获取cookie中的user_id
  let token = Cookies.get('XSRF-TOKEN')
  let _t = (new Date()).getTime()
  let str = uid + token + _t + '=='
  let secret = MD5(str).toString()

  return pbrAxios.post('/api/front/checkUserId', {token, uid, _t, secret})
}


/**
 * 验证财经系统当前登录用户，并注入cookie
 * @param params
 * @returns {AxiosPromise<any>}
 */
const checkFinanceUser = (params) => {
  return pbrAxios.post('/api/front/checkFinanceUser', params)
}
function checkCookieToken () {
// !this.Cookies.get('XSRF-TOKEN-MD5') || this.Cookies.get('XSRF-TOKEN-MD5') === 'undefined'
  let cookieToken = Cookies.get('XSRF-TOKEN-MD5')
  if (cookieToken) {
    return true
  }
  return false
}

function setCookie (name = 'XSRF-TOKEN-MD5', val) {
  Cookies.set(name, val)
}
function removeCookie (name = 'XSRF-TOKEN-MD5', val) {
  Cookies.remove(name)
}

export default {
  queryURLParams,
  checkUserId,
  checkFinanceUser,
  checkCookieToken,
  getSilkRoadToken,
  checkSilkRoadToken,
  setCookie,
  removeCookie
}
